// 날짜(date) 단위 문자열의 표시 변환. Date 객체를 거치지 않고 문자열 조작으로만 처리해
// 사용자 timezone 함정을 회피한다.

export type LocalDatePattern =
  | "YYYY-MM-DD"
  | "YYYY/MM/DD"
  | "YYYY.MM.DD"
  | "YY.MM.DD"
  | "long";

export type Language = "ko" | "en";

const MONTH_NAMES_EN = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const YYYY_MM_DD_PREFIX = /^(\d{4})-(\d{2})-(\d{2})/;

export function formatLocalDate(
  yyyyMmDd: string,
  pattern: LocalDatePattern,
  language: Language = "ko"
): string {
  if (!yyyyMmDd) return "";
  const match = YYYY_MM_DD_PREFIX.exec(yyyyMmDd);
  if (!match) return yyyyMmDd;

  const [, year, month, day] = match;
  const yy = year.slice(-2);
  const monthNum = Number(month);
  const dayNum = Number(day);

  switch (pattern) {
    case "YYYY-MM-DD":
      return `${year}-${month}-${day}`;
    case "YYYY/MM/DD":
      return `${year}/${month}/${day}`;
    case "YYYY.MM.DD":
      return `${year}.${month}.${day}`;
    case "YY.MM.DD":
      return `${yy}.${month}.${day}`;
    case "long":
      if (language === "en") {
        const monthName = MONTH_NAMES_EN[monthNum - 1];
        return `${monthName} ${dayNum}, ${year}`;
      }
      return `${year}년 ${monthNum}월 ${dayNum}일`;
    default:
      return `${year}-${month}-${day}`;
  }
}
